var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconClock = function SvgIconClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-clock_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440 0v3704H0V0h1440z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-clock_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.9 0c5.468 0 9.9 4.432 9.9 9.9s-4.432 9.9-9.9 9.9S0 15.368 0 9.9 4.432 0 9.9 0zm0 1.8a8.1 8.1 0 1 0 0 16.2 8.1 8.1 0 0 0 0-16.2zm-.18 2.825.113.007c.502.067.868.503.868 1.008v4.63l2.25 2.246.087.099a1.09 1.09 0 0 1-.082 1.404c-.399.423-1.092.423-1.51.003l-2.549-2.55-.063-.071-.08-.097a1.001 1.001 0 0 1-.194-.59V5.64l.007-.113c.063-.511.483-.902.982-.902h.172z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-clock_svg__a)",
    transform: "translate(-859 -1632)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-clock_svg__b)",
    transform: "translate(861.111 1634.1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#292A2B",
    d: "M0 0h19.8v19.8H0V0z"
  })))));
};
export default SvgIconClock;